export const BASE_URL_V2 = "https://dummyjson.com";

export const WEB_ROUTES = {
  ACCOUNT: "/account",
  DASHBOARD: "/dashboard",
  USER_MANAGEMENT: "/user-management",
  USER_DETAILS: "/user-management/user-details",
  CATEGORY_MANAGEMENT: "/category-management",
  MENTAL_HEALTH_MANAGEMENT: "/mental-health-management",
  DIETARY_RESTRICTIONS: "/dietary-restrictions",

  ACTIVITY_MANAGEMENT: "/activity-management",

  GENRE_MANAGEMENT: "/genre-management",
  BADGE_MANAGEMENT: "/badge-management",

  QUESTION_MANAGEMENT: "/question-management",
  TOURNAMENT_MANAGEMENT: "/tournament-management",
  TOURNAMENT_QUESTION_MANAGEMENT: "/tournament-question-management",

  PRODUCT_MANAGEMENT: "/product-management",

  PRODUCTS_MANAGEMENT: "/category-management/products",
  REFERRALS_MANAGEMENT: "/referrals-management",

  ALBUMS_MANAGEMENT: "/albums-management",
  ALBUMS_CONTENT_MANAGEMENT: "/albums-management/content",
  CONTENTS_MANAGEMENT: "/contents-management",
  CONTENTS_DETAILS_MANAGEMENT: "/contents-management/details",
  EARLY_ACCESS_MANAGEMENT: "/early-access-management",
  SHOW_DATA: "/early-access-management/csv-data",

  ORDER_MANAGEMENT: "/order-management",
  ORDER_DETAILS: "/order-details",
  FAQ_MANAGEMENT: "/faq-management",
  REWARD_MANAGEMENT: "/reward-management",
  LEVELS_MANAGEMENT: "/levels-management",
  PACKAGES_MANAGEMENT: "/packages-management",

  BADGES_MANAGEMENT: "/badges-management",
  BANNERS_MANAGEMENT: "/banners-management",
  ADVERTISEMENT_MANAGEMENT: "/advertisement-management",
  SHOW_ADS: "/advertisement-management/show-ads",

  // GAME_MANAGEMENT: "/game-management",
  // GAME_CATEGORIES_MANAGEMENT: "/game-categories-management",
  // GAME_TEAMS_MANAGEMENT: "/game-teams-management",
  // GAME_QUESTION_MANAGEMENT: "/game-question-management",

  SEND_NOTIFICATION: "/send-notification",
  SETTING: "/settings",
  PAGE_MANAGEMENT: "/content-management",
};

export const QUESTION_TYPE = {
  EASY: 10,
  MEDIUM: 30,
  HARD: 50,
};

export const GAME_TYPE = {
  SOLO: 10,
  TEAM: 20,
};

export const BREAKPOINTS = {
  MOBILE: 991,
};
export const apiUrl = {
  auth: "auth",
  api: "api",
  role: "admin",
  user: "user",
  login: "login",
  forgotPass: "forgot-password",
  changePass: "change-password",

  // tournament
  tournament: "tournament",
  livetournament: "tournament/live",
  scheduletournament: "tournament/schedule",
  ageGroup: "age-group",
  refund: "refund",
  startmatch: "match/start",
  endmatch: "match/end",
};

// DATA ->
// DUMMY
export const sportsStateList = [
  { value: 1, label: "State 1" },
  { value: 2, label: "State 2" },
  { value: 3, label: "State 3" },
];

export const sportsTypeList = [{ value: "Baseball", label: "Baseball" }];

export const formateTTime = (dateStr) => {
  const date = new Date(dateStr);
  const options = { hour: "numeric", minute: "2-digit", hour12: true };
  const timeFormatted = date.toLocaleString("en-US", options);
  return timeFormatted;
};

export const formatedDate = (dateStr) => {
  const date = new Date(dateStr);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    // hour: 'numeric',
    // minute: '2-digit',
    // hour12: true
  };
  const dateFormatted = date.toLocaleString("en-US", options);
  return dateFormatted;
};

export const chartData = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Yearly",
      data: [],
      fill: true,
      backgroundColor: "rgba(75,192,192,0.2)",
      borderColor: "rgba(75,192,192,1)",
    },
  ],
};
export const legends = ["Weekdays", "Normal Days"]; // Your custom labels

export const chartOptions = {
  plugins: {
    legend: {
      position: "top",
      display: false,
      align: "end",
      labels: {
        usePointStyle: true,
        // generateLabels: function (chart) {
        //   if (!chart || !chart.data || !chart.data.datasets) return [];
        //   return chart.data.datasets.map((dataset, index) => ({
        //     text: `${legends[index]}`,
        //     fillStyle: dataset.backgroundColor,
        //     hidden: !chart.isDatasetVisible(index),
        //     lineCap: dataset.borderCapStyle,
        //     lineDash: dataset.borderDash,
        //     lineDashOffset: dataset.borderDashOffset,
        //     lineJoin: dataset.borderJoinStyle,
        //     strokeStyle: dataset.borderColor,
        //     dataset: dataset,
        //     index: index,
        //   }));
        // },
      },
    },
    title: {
      display: true,
      text: "Total Tournament Participation",
      color: "#000",
      font: {
        size: 20,
        weight: "bold",
        family: "Arial, sans-serif",
      },
      padding: {
        top: 10,
        bottom: 20,
      },
      align: "start",
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Month", // Label for the x-axis
      },
    },
    y: {
      title: {
        display: true,
        text: "Earning", // Label for the x-axis
      },

      beginAtZero: true,
      ticks: {
        maxTicksLimit: 6,
        callback: function (value) {
          if (value >= 1000) {
            return `${(value / 1000).toFixed(0)}k`;
          }
          return value;
        },
      },
    },
  },
  animation: false, // Disable animations to prevent errors
};
export const chartOptionsOrder = {
  plugins: {
    legend: {
      position: "top",
      display: false,
      align: "end",
      labels: {
        usePointStyle: true,
        // generateLabels: function (chart) {
        //   if (!chart || !chart.data || !chart.data.datasets) return [];
        //   return chart.data.datasets.map((dataset, index) => ({
        //     text: `${legends[index]}`,
        //     fillStyle: dataset.backgroundColor,
        //     hidden: !chart.isDatasetVisible(index),
        //     lineCap: dataset.borderCapStyle,
        //     lineDash: dataset.borderDash,
        //     lineDashOffset: dataset.borderDashOffset,
        //     lineJoin: dataset.borderJoinStyle,
        //     strokeStyle: dataset.borderColor,
        //     dataset: dataset,
        //     index: index,
        //   }));
        // },
      },
    },
    title: {
      display: true,
      text: "Total Orders",
      color: "#000",
      font: {
        size: 20,
        weight: "bold",
        family: "Arial, sans-serif",
      },
      padding: {
        top: 10,
        bottom: 20,
      },
      align: "start",
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Month", // Label for the x-axis
      },
    },
    y: {
      title: {
        display: true,
        text: "Order", // Label for the x-axis
      },

      beginAtZero: true,
      ticks: {
        maxTicksLimit: 6,
        callback: function (value) {
          if (value >= 1000) {
            return `${(value / 1000).toFixed(0)}k`;
          }
          return value;
        },
      },
    },
  },
  animation: false, // Disable animations to prevent errors
};
